import React, { useState } from "react";
import { Menu } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({ sections }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [hovered, setHovered] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const isExpanded = !collapsed || hovered;

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`h-screen fixed left-0 top-0 z-50 bg-gray-900 text-white transition-all duration-300
      ${isExpanded ? "w-64" : "w-16"}`}
    >
      {/* Toggle (optional manual control) */}
      <div className="flex justify-end p-3">
        <button onClick={() => setCollapsed(!collapsed)}>
          <Menu />
        </button>
      </div>

      {/* Menu */}
      <div className="flex flex-col gap-2 px-2">

        {sections.map((section, idx) => (
          <div key={idx} className="flex flex-col gap-1">

            {section.items.map((item, i) => {
              const isActive = location.pathname === item.path;

              return (
                <div
                  key={i}
                  onClick={() => {
                    if (item.path) navigate(item.path);
                  }}
                  className={`flex items-center gap-3 p-2 rounded-md cursor-pointer transition
                  ${isActive ? "bg-gray-700" : "hover:bg-gray-800"}`}
                >
                  {/* Icon */}
                  <div>{item.icon}</div>

                  {/* Name */}
                  {isExpanded && (
                    <span className="text-sm whitespace-nowrap">
                      {item.title}
                    </span>
                  )}
                </div>
              );
            })}

          </div>
        ))}

      </div>
    </div>
  );
};

export default Sidebar;